import React, { useState } from "react";

export default function Footer() {


  return (
    <div className="footer">
      <p>Diseño web: Sergio Salgado</p>
      <p>Esta web está programada con <a href="https://react.dev/">REACT.JS</a></p>
    </div>

  );
}
